module.exports = __webpack_public_path__ + "static/media/deleteGrey.fed567e7.svg";